import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Header from './Header';



const ModalCreateExpenseForm = () => {
    const server_app_api_php = window.SERVER_APP_API_PHP;
    const [companyID] = useState(1); // Replace with actual companyID
    const [location] = useState('');
  const [businessType, setBusinessType] = useState('');
  const [businessLocations, setBusinessLocations] = useState([]);
  const [businessLocationID, setBusinessLocationID] = useState('');
  const [expense, setExpense] = useState('');
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  let business_locationIDMain = localStorage.getItem('business_locationIDMain')
if(business_locationIDMain === null){
  business_locationIDMain = '';
}

  useEffect(() => {
    // Create formData object
    const formData = new FormData();
    formData.append("apiType", 'getBusinessLocationOnUploadForm');
    formData.append("companyID", companyID);
    formData.append("location", business_locationIDMain);
    // Fetch plot options from the backend using POST method
    axios.post(`${server_app_api_php}/server/index.php`, formData)
      .then(response => {
        setBusinessLocations(response.data);
      })
      .catch(error => {
        //alert("There was an error fetching the Business Locations!", error);
      });
    }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    switch (name) {
      case 'businessType':
        setBusinessType(value);
        break;
      case 'business_locationIDCreateExpense':
        setBusinessLocationID(value);
        break;
      case 'expenseCreate':
        setExpense(value);
        break;
      default:
        break;
    }
  };

  /*
  const handleSubmit = (e) => {
    e.preventDefault();
    setIsButtonDisabled(true);

    if (businessLocationID && expense && businessType) {
      const formData = {
        business_locationIDCreateExpense: businessLocationID,
        expenseCreate: expense,
        createCompanyID: companyID,
        businessType,
        apiType: 'createExpenses',
      };

      axios.post(`${server_app_api_php}/upload.php`, formData)
        .then(response => {
          alert(response.data);
          // Reset form fields
          setBusinessLocationID('');
          setExpense('');
          setBusinessType('');
        })
        .catch(error => {
          alert('There Seems To be a Problem with Your Internet Connectivity. If this Problem continues, kindly contact Support Team');
          console.error('There was an error!', error);
        })
        .finally(() => {
          setIsButtonDisabled(false);
        });
    } else {
      alert('Please fill all fields.');
      setIsButtonDisabled(false);
    }
  };
  */

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsButtonDisabled(true);

    if (businessLocationID && expense && businessType) {
      // Create a new FormData object
      const formData = new FormData();
      formData.append('business_locationIDCreateExpense', businessLocationID);
      formData.append('expenseCreate', expense);
      formData.append('createCompanyID', companyID);
      formData.append('businessType', businessType);
      formData.append('apiType', 'createExpenses');

      // Send the FormData object using Axios
      axios.post(`${server_app_api_php}/index.php`, formData)
        .then(response => {
          alert(response.data);
          // Reset form fields
          setBusinessLocationID('');
          setExpense('');
          setBusinessType('');
        })
        .catch(error => {
          alert('There Seems To be a Problem with Your Internet Connectivity. If this Problem continues, kindly contact Support Team');
          //console.error('There was an error!', error);
        })
        .finally(() => {
          setIsButtonDisabled(false);
        });
    } else {
      alert('Please fill all fields.');
      setIsButtonDisabled(false);
    }
  };


  return (
    <>
    <Header />
    <hr />
    <div className="mt-5" id="modalCreateExpenseForm" tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
      
      <div className="modal-dialog modal-lg modal-notify modal-info" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <p className="heading lead">Create Expenses</p>
        
          </div>
          <div className="modal-body">
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-lg-12 col-xl-12 col-md-12 md-form md-outline">
                  <select className="custom-select d-block w-100" id="businessType" name="businessType" value={businessType} onChange={handleInputChange}>
                    <option value="">Business Type</option>
                    <option value="Houses">Houses</option>
                    <option value="Plots">Plots</option>
                  </select>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-12 col-xl-12 col-md-12 md-form md-outline">
                  <select className="custom-select d-block w-100" id="business_locationIDCreateExpense" name="business_locationIDCreateExpense" value={businessLocationID} onChange={handleInputChange} required>
                    <option value="">Choose Business Location..</option>
                    {businessLocations.map(location => (
                      <option key={location.businessLocationID} value={location.businessLocationID}>
                        {location.businessLocationName}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-lg-12 col-xl-12 col-md-12 md-form md-outline">
                  <div className="md-form md-outline">
                    <input type="text" id="expenseCreate" name="expenseCreate" className="form-control form-control-md" value={expense} onChange={handleInputChange} required />
                    <label htmlFor="expenseCreate">Expense</label>
                  </div>
                </div>
                <input type="hidden" id="createCompanyID" value={window.userCompanyID} />
                <div className="text-center mt-0">
                  <button type="submit" className="btn btn-success" id="createExpenses" disabled={isButtonDisabled}>
                    Create <i className="fas fa-pen-alt ml-1"></i>
                  </button>
                </div>
              </div>
            </form>
          </div>
          <div className="modal-footer">
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default ModalCreateExpenseForm;
